
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Zap, Target } from 'lucide-react';

interface WritingPromptsProps {
  maxCharacters: number;
}

const WritingPrompts: React.FC<WritingPromptsProps> = ({ maxCharacters }) => {

  return (
    <Card className="bg-white/80 backdrop-blur-lg border-white/20">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Target className="h-5 w-5" />
          Writing Prompts
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
          <h4 className="font-medium text-blue-800 mb-2 flex items-center gap-2">
            <Zap className="h-4 w-4" />
            Smart Optimization
          </h4>
          <p className="text-sm text-blue-700">
            Our AI automatically identifies and uses the most important details from your biography, 
            ensuring personalized content while keeping costs efficient. Focus on key relationships, 
            preferences, and meaningful experiences.
          </p>
        </div>

        <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-100">
          <h4 className="font-medium text-green-800 mb-2">📝 Optimized Character Limit</h4>
          <p className="text-sm text-green-700">
            Keep your biography under {maxCharacters} characters. This optimized limit ensures faster processing, 
            lower costs, and better personalization quality while maintaining all the rich detail you want to include.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default WritingPrompts;
